<section class="h-8 items-center ml-4 flex">
  <div *ngFor="let link of links" class="link text-base text-grey/52 font-secondary-medium uppercase cursor-pointer outline-none pr-5 h-8 group [&.active]:text-grey-1000" [routerLink]="link.routerLink" [routerLinkActive]="['active']">
    {{ link.name }}
    <div class="group-[.active]:bg-primary-1 group-[.active]:border-[0.0625rem] group-[.active]:border-solid group-[.active]:border-primary-1 group-[.active]:mt-[0.3125rem] group-[.active]:rounded-[0.0938rem] group-[.active]:h-[0.1875rem]"></div>
  </div>
</section>
